const getCompaniesState = state => state.companiesReducer;

export const getCompanyDropdownList = state => getCompaniesState(state).companyDropdownList;

export const getSelectedCompany = state => getCompaniesState(state).selectedCompany;

export const getIsCompanyDropdownLoading = state => getCompaniesState(state).isLoading;

export const getSwitchCompanySuccess = state => getCompaniesState(state).switchCompanySuccess;
export const getIsSwitchingCompany = state => getCompaniesState(state).isSwitchingCompany;